import React from 'react';
import { Empty, Space, Typography } from 'antd';

import { useEditorDoc } from '../../EditorProvider';
import type { RebusDoc } from './doc';
import { ImageUploader } from './ImageUploader';

// O canvas do rébus NÃO tem grade: não há célula, coordenada nem arrasto. Ou ele
// mostra a imagem como o jogador vai ver, ou mostra o empty state com o botão de
// subir. É o único consumidor do DocContext neste módulo (regra de perf do shell).

export const Canvas: React.FC = () => {
  const doc = useEditorDoc<RebusDoc>();

  if (!doc.imagem) {
    return (
      <div style={{ minWidth: 320, padding: 24, border: '1px dashed #d9d9d9', borderRadius: 8 }}>
        <Space direction="vertical" align="center" style={{ width: '100%' }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhuma imagem ainda — é ela que o jogador decifra."
          />
          <ImageUploader />
        </Space>
      </div>
    );
  }

  return (
    <Space direction="vertical" size={4}>
      <img
        src={doc.imagem}
        alt="Imagem do rébus"
        style={{ maxWidth: 480, maxHeight: 480, display: 'block' }}
      />
      <Typography.Text type="secondary">É assim que o jogador vê o rébus.</Typography.Text>
    </Space>
  );
};
